<app-page-title [title]="'LINK AN EXISTING CLIENT ACCOUNT'"></app-page-title>

<form
    name="adopt-child-form"
    [formGroup]="userForm"
    (ngSubmit)="onSubmit()"
>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <p class="alert alert-warning">Use this functionality to link another existing account into your account. </p>
                <p>An email request will be sent to the account you wish to link with instructions
                    advising the user to confirm your request.</p>
                <p>Please enter the email of the account you wish to link:</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-5">
            <div class="form-group">
                <label>Email address</label>
                <input
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="Enter email"
                    formControlName="email"
                    autofocus
                />
                <small
                    class="error"
                    *ngIf="f.email.dirty && f.email.errors?.required"
                >Email is required.</small>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <button
                    name="confirmationYesBtn"
                    class="btn btn-primary"
                    type="button"
                    (click)="onSubmit()"
                >
                    Link
                </button>
            </div>
        </div>
    </div>
</form>
